module.exports = __webpack_public_path__ + "static/default-e8e5a95a1106f317f99690eb34810d29.jpg";